import { render } from "./Login.vue?vue&type=template&id=27d755ac"
import script from "../js/login.js?vue&type=script&lang=js"
export * from "../js/login.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinumlandscapemi/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__